import { useSelector } from 'react-redux';

import { getCustomPizzaDetails, getOfferDetails, getPizzaByHalvesDetails } from '../auxComponents';

import { isComplement, isCustomPizza, isOffer, isPizzaByHalves, isProduct } from '~models/product';

import { usePizzaByHalvesSpecialtyData } from './usePizzaByHalvesSpecialtyData';

export const useProductDetail = item => {
  const byopVariants = useSelector(state => state.customPizza?.helpers?.byop?.variants);
  const { pizzaSpecialtyData, baseIngredients } = usePizzaByHalvesSpecialtyData(item);

  const showVariantName = isProduct(item) && item?.variantName;

  const collapsibleContent = [
    isOffer(item) && getOfferDetails(item, baseIngredients),
    isCustomPizza(item, byopVariants) && getCustomPizzaDetails(item),
    isPizzaByHalves(item) && getPizzaByHalvesDetails(item, pizzaSpecialtyData)
  ].find(Boolean);

  return {
    showVariantName,
    isComplement: isComplement(item),
    isOffer: isOffer(item),
    isCustomPizza: isCustomPizza(item, byopVariants),
    collapsibleContent,
    baseIngredients
  };
};
